import axios from "axios";
//console.log('process.env.VUE_APP_SERVERNAME is: ',process.env.VUE_APP_SERVERNAME )

let servername = 'https://' + window.location.hostname
//console.log('servername starts as: ', servername)
if (servername === 'https://localhost') {
  servername = 'http://localhost:8700';
//  console.log('servername changed to: ', servername)
}

import store from '../store'

export default {

  // QuickConnect stuff
  async getTodaysQuickConnect(today) {
    let myroute = servername + "/todaysqc";
    const params = {
      today: today,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    // System Messages
  async getMessage() {
    let myroute = servername + "/getmessage";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data[0];} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async addMessage(userID, messageText, messageStart, messageEnd) {
    let myroute = servername + "/addmessage";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken,
      userID: userID,
      messageText: messageText,
      messageStart: messageStart,
      messageEnd: messageEnd
    };
    try {let res = await axios.get(myroute, { params });
      return res.data[0];} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async getUserCountsSubType() {
    let myroute = servername + "/getUserCountsSubType";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };

    try {let res = await axios.get(myroute, { params });
      return res.data.recordset;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async charterInvitationsUsedCount() {
    let myroute = servername + "/charterInvitationsUsedCount";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };

    try {let res = await axios.get(myroute, { params });
      return res.data.recordset;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

      async charterInvitationsOpenCount() {
    let myroute = servername + "/charterInvitationsOpenCount";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };

    try {let res = await axios.get(myroute, { params });
      return res.data.recordset;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getMyQCAnswerToday(userID, today) {
    let myroute = servername + "/getmyqcanswertoday";
    var whatistoken = store.getters.getToken
    const params = {
      userID: userID,
      today: today,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 

  },

  async getMyAnswer(userID, viewPointID) {
    let myroute = servername + "/getmyanswer";
    const params = {
      userID: userID,
      viewPointID: viewPointID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getAnswers(userID, viewPointID) {
    let myroute = servername + "/getanswers";
    const params = {
      userID: userID,
      viewPointID: viewPointID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getQuickConnectQuestions() {
    let myroute = servername + "/getquickconnectquestions";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getThisQCQuestion(viewPointID) {
    let myroute = servername + "/getthisqcquestion";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken,
      viewPointID: viewPointID
    };
    //console.log('ES is about to send these params: ', params)
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async editThisQCQuestion(viewPointID, viewPointQuestion, viewPointDate, userID) {
    let myroute = servername + "/editthisqcquestion";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken,
      ViewPointID: viewPointID,
      ViewPointQuestion: viewPointQuestion,
      ViewPointDate: viewPointDate,
      UserID: userID

    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getAllQuickConnectQuestions() {
    let myroute = servername + "/getallquickconnectquestions";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },


    async deleteQuickConnectQuestion(viewPointID) {
    let myroute = servername + "/deletequickconnectquestion";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken,
      viewPointID: viewPointID
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async addQuickConnectQuestion(qcDate, qcQuestion, qcUserID) {
    let myroute = servername + "/addquickconnectquestion";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken,
      qcDate: qcDate,
      qcQuestion: qcQuestion,
      qcUserID: qcUserID

    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getCircleAnswersToday(userID, today) {
    let myroute = servername + "/getcircleanswerstoday";
    const params = {
      userID: userID,
      today: today,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async saveMyAnswer(userID, qcID, myanswer) {
    let myroute = servername + "/savemyanswer";
    const params = {
      userID: userID,
      qcID: qcID,
      myanswer: myanswer,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //Story/Memory stuff

  async getMyStories(userID, recordStart, pageLength) {
    let myroute = servername + "/mystories";
    const params = {
      userID: userID,
      recordStart: recordStart,
      pageLength: pageLength,
      recordCount: 0,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } ;
  },

    async getDrafts(userID, recordStart, pageLength) {
    let myroute = servername + "/mydrafts";
    const params = {
      userID: userID,
      recordStart: recordStart,
      pageLength: pageLength,
      recordCount: 0,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } ;
  },

  async getMyJournal(userID, recordStart, pageLength) {
    let myroute = servername + "/myjournal";
    const params = {
      userID: userID,
      recordStart: recordStart,
      pageLength: pageLength,
      recordCount: 0,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getAllStories(userID, recordStart, pageLength) {
    let myroute = servername + "/allstories";

    const params = {
      userID: userID,
      recordStart: recordStart,
      pageLength: pageLength,
      recordCount: 0,
     token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async searchMemories(userID, recordStart, pageLength, searchTerm) {
    let myroute = servername + "/searchMemories";
    const params = {
      userID: userID,
      recordStart: recordStart,
      pageLength: pageLength,
      recordCount: 0,
      searchTerm: searchTerm,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getThisStory(memoryID) {
    let myroute = servername + "/thisstory";
    const params = {
      storyID: memoryID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async getHeartStatus(storyID, userID) {
    let myroute = servername + "/getHeartStatus";
    const params = {
      storyID: storyID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async getHeartList(storyID, userID) {
    let myroute = servername + "/getHeartList";
    //console.log('ES receives storyID, userID', storyID, userID)
    const params = {
      storyID: storyID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async getHeartCount(storyID) {
    let myroute = servername + "/getHeartCount";
    const params = {
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };

    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async addHeartStatus(storyID, userID) {
    let myroute = servername + "/addHeartStatus";
    const params = {
      storyID: storyID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data[0];} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async removeHeartStatus(storyID, userID) {
    let myroute = servername + "/removeHeartStatus";
    const params = {
      storyID: storyID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data[0];} 
    catch (error) {
      console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //COMMENT MANAGEMENT SECTION

  async addComment(storyID, userID, commentText) {
    let myroute = servername + "/addcomment";
    const params = {
      storyID: storyID,
      userID: userID,
      commentText: commentText,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data[0];} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async getCommentTotal(storyID) {
     let myroute = servername + "/getcommenttotal";
    const params = {
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data.returnValue;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

      async getComments(storyID) {
     let myroute = servername + "/getcomments";
    const params = {
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data.recordset;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

      async deleteComment(commentID) {
     let myroute = servername + "/deletecomment";
    const params = {
      commentID: commentID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data.recordset;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },  



  //DELETE MEMORY 

  async deleteMemory(storyID) {
    let myroute = servername + "/deletememory";
    const params = {
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async newDraft(userID, storyData) {
    let myroute = servername + "/addmemory";
    if (storyData.Hidden === true) {
      var hidden = 1
    } else {var hidden = 0}
    var params = {};
    if (storyData.StoryTypeID === 1) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        Hidden: hidden,
        CircleID: null,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 2) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: circleID,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 3) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        StoryIngredients: storyData.StoryIngredients,
        Hidden: hidden,
        CircleID: circleID,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 4) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        StoryIngredients: storyData.StoryIngredients,
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: circleID,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }
    //console.log('params is: ', params)
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async updateDraft(storyData, newCircle, setType) {
    if (storyData.Hidden === true) {
      var hidden = 1
    } else {var hidden = 0}
    let myroute = servername + "/updatememory";
    var params = {};
    if (storyData.StoryTypeID === 1) {
      params = {
        StoryID: Number(storyData.StoryID),
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(setType),
        Hidden: hidden,
        CircleID: null,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 2) {
      params = {
        StoryID: Number(storyData.StoryID),
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(storyData.StoryTypeID),
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: null,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 3) {
      params = {
        StoryID: Number(storyData.StoryID),        
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(storyData.StoryTypeID),
        StoryIngredients: storyData.StoryIngredients,
        Hidden: hidden,
        CircleID: null,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 4) {
      params = {
        StoryID: Number(storyData.StoryID),
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(storyData.StoryTypeID),
        StoryIngredients: storyData.StoryIngredients,
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: null,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  }
  },

  async newMemory(userID, storyData, circleID) {
//    console.log('reaching newMemory ES')
    let myroute = servername + "/addmemory";
    if (storyData.Hidden === true) {
      var hidden = 1
    } else {var hidden = 0}
    var params = {};
    if (storyData.StoryTypeID === 1) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        CircleID: circleID,
        Hidden: hidden,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 2) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: circleID,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 3) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        StoryIngredients: storyData.StoryIngredients,
        Hidden: hidden,
        CircleID: circleID,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 4) {
      params = {
        userID: userID,
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: storyData.StoryTypeID,
        StoryIngredients: storyData.StoryIngredients,
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: circleID,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async updateMemory(storyData, newCircle, setType) {
    let myroute = servername + "/updatememory";
    if (storyData.Hidden === true) {
      var hidden = 1
    } else {var hidden = 0}
    var params = {};
    if (storyData.StoryTypeID === 1) {
      params = {
        StoryID: Number(storyData.StoryID),
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(setType),
        Hidden: hidden,
        CircleID: Number(newCircle),
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 2) {
      params = {
        StoryID: Number(storyData.StoryID),
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(storyData.StoryTypeID),
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: Number(newCircle),
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 3) {
      params = {
        StoryID: Number(storyData.StoryID),        
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(storyData.StoryTypeID),
        StoryIngredients: storyData.StoryIngredients,
        Hidden: hidden,
        CircleID: Number(newCircle),
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }

    if (storyData.StoryTypeID === 4) {
      params = {
        StoryID: Number(storyData.StoryID),
        StoryTitle: storyData.StoryTitle,
        StoryText: storyData.StoryText,
        StoryTypeID: Number(storyData.StoryTypeID),
        StoryIngredients: storyData.StoryIngredients,
        Interviewee: storyData.Interviewee,
        Hidden: hidden,
        CircleID: Number(newCircle),
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    }
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  }
  },

  async getTraditions() {
    let myroute = servername + "/gettraditions";
    let res = await axios.get(myroute);
    return res.data;
  },

  async getInterviews() {
    let myroute = servername + "/getinterviews";
    let res = await axios.get(myroute);
    return res.data;
  },

  //Media Stuff

  async getMedia(storyID) {
    let myroute = servername + "/getMedia";
    const params = {
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getNewMedia(userID) {
    let myroute = servername + "/getnewmedia";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },
  async removeNewMedia(userID) {
    let myroute = servername + "/removenewmedia";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async makeFeature(mediaLoc) {
    let myroute = servername + "/makeFeature";
    const params = {
      mediaLoc: mediaLoc,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async deleteMedia(mediaLoc) {
    let myroute = servername + "/deletemedia";
    const params = {
      mediaLoc: mediaLoc,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async addNewBlob(formData) {
    let myroute = servername + "/addNewBlob";
    let res = await axios
      .post(myroute, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    return res;
  },

  async addNewProfileBlob(formData) {
    let myroute = servername + "/addNewProfileBlob";
    let profileReturn = await axios
      .post(myroute, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((profileSas) => {
        // console.log(
        //   "eventservice addnewProfileblob then, profileSas.data is: ",
        //   profileSas.data
        // );
        return profileSas.data;
      });
    return profileReturn;
  },

  async getSASKey(mediaLoc) {
    let myroute = servername + "/getSASKey";
    const params = {
      mediaLoc: mediaLoc,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //Book Stuff
  async getBooks(userID) {
    let myroute = servername + "/getBooks";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getMyBookList(userID) {
    let myroute = servername + "/getmybooklist";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //used to get the user's books that do not already contain a specific story
  async getBooksToAddStory(userID, storyID) {
    console.log('ES sees book info as: ', userID, storyID)
    let myroute = servername + "/getbookstoaddtostory";
    const params = {
      userID: userID,
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async addToBooks(bookID, storyID) {
    console.log('ES addToBooks receives: ', bookID, storyID)
    let myroute = servername + "/addtobooks";
    const params = {
      bookID: bookID,
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async deleteBook(bookID, userID) {
    let myroute = servername + "/deleteBook";
    const params = {
      bookID: bookID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async removeFromBooks(bookID, storyID) {
    let myroute = servername + "/removefrombooks";
    const params = {
      bookID: bookID,
      storyID: storyID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getBookContent(userID, bookID) {
    let myroute = servername + "/getbookcontent";
    const params = {
      userID: userID,
      bookID: bookID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async newBook(userID, bookTitle, tcDate, circleID) {
    let myroute = servername + "/newbook";
    const params = {
      userID: userID,
      bookTitle: bookTitle,
      tcDate: tcDate,
      circleID: circleID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async editBook(userID, bookID, bookTitle, tcDate, circleID) {
    let myroute = servername + "/editbook";
    const params = {
      userID: userID,
      bookID: bookID,
      bookTitle: bookTitle,
      tcDate: tcDate,
      circleID: circleID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //Authentication Stuff

  async getUser(userEmail) {
    let myroute = servername + "/user";
    const params = {
      userEmail: userEmail,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },
  

  async getUserInfo(userID) {
    let myroute = servername + "/userinfo";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async login(userEmail, userPassword) {
    let myroute = servername + "/auth";
//    let myroute = 'https://' + window.location.hostname + "/auth";
    const params = {
      userEmail: userEmail,
      userPassword: userPassword,
    };

    let res = await axios.get(myroute, { params });
    return res.data;
  },

  
  async registration(
    userFirst,
    userLast,
    userDisplayName,
    userEmail,
    userPassword
  ) {
    let myroute = servername + "/dupCheck";
    const params = {
      userFirst: userFirst,
      userLast: userLast,
      userDisplayName: userDisplayName,
      userEmail: userEmail,
      userPassword: userPassword,
    };
    let check = await axios.get(myroute, { params });
    if (check.data === "duplicate") {
      return check.data;
    } else {
      let nextroute = servername + "/register";
      let res = await axios.get(nextroute, { params });
      return res.data;
    }
  },

  async invitationRegistration(
    userFirst,
    userLast,
    userDisplayName,
    userEmail,
    userPassword,
    invitationCode
  ) {
    let myroute = servername + "/dupCheck";
    const params = {
      userFirst: userFirst,
      userLast: userLast,
      userDisplayName: userDisplayName,
      userEmail: userEmail,
      userPassword: userPassword,
      invitationCode: invitationCode
    };
    let check = await axios.get(myroute, { params });
    if (check.data === 'Duplicate' || check.data === 'Member') {
      return check.data;
    } 
    if (check.data === 'invalid invitation') {
      return check.data;
    }

      let nextroute = servername + "/invitedregister";
      let res = await axios.get(nextroute, { params });
      return res.data;

  },

  async verifyRegistration(verifyCode, userEmail) {
    let myroute = servername + "/verifyRegistration";
    const params = {
      userEmail: userEmail,
      verifyCode: verifyCode,
    };

    let res = await axios.get(myroute, { params });
    return res.data;
  },

    async acceptPolicy(userID) {
    let myroute = servername + "/acceptpolicy";
    // console.log(
    //   "starting acceptpolicy in ES",
    //   userID, 
    //   store.getters.getReauthToken
    // );
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    // if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    // location.href = '//localhost:8080/login';} else {
    //   location.href = 'https://login.memoriesforus.com/login';
    // }
  }
    
  },

  async updateUser(
    userID,
    userFirst,
    userLast,
    userDisplayName,
    userEmail,
    changeEmail
  ) {
    let myroute = servername + "/updateUser";
    let res = "";
    const params = {
      userID: userID,
      userFirst: userFirst,
      userLast: userLast,
      userDisplayName: userDisplayName,
      newEmail: userEmail,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 

    //run api to send email change notification/verification
    if (changeEmail === true) {
      let secondroute = servername + "/changeEmail";
      await axios.get(secondroute, { params });
    }
    return res.data;
  },

  async updatePassword(userID, oldPassword, newPassword) {
    let myroute = servername + "/updatePassword";
    const params = {
      userID: userID,
      oldPassword: oldPassword,
      newPassword: newPassword,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //Start process to reset lost password by sending reset code sent via email
  async forgotPassword(email) {
  let myroute = servername + "/forgot";
  const params = {
    email: email
  };

  let res = await axios.get(myroute, { params });
  return 'Check your email to reset your password.';
},

  //Start process to reset lost password by verifying the reset code sent via email
    async resetCheck(email, verifyCode) {
    let myroute = servername + "/resetCheck";
    const params = {
      email: email,
      verifyCode: verifyCode
    };

    let res = await axios.get(myroute, { params });
    return res.data;
  },

 
  //Finish process to reset lost password 
    async resetPassword(email, password) {
    let myroute = servername + "/resetPassword";
    const params = {
      email: email,
      password: password
    };

    let res = await axios.get(myroute, { params });
    return res.data;
  }, 

  //Circle

  async getMyCircles(userID) {
    let myroute = servername + "/getmycircles";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  }
    
  },

  async getCircleMembersAll(circleID) {
    let myroute = servername + "/getcirclemembersall";
    const params = {
      circleID: circleID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getCirclePickList(circleID, userID) {
    let myroute = servername + "/getcirclepicklist";
    const params = {
      circleID: circleID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async searchToAddToEveryone(userID, firstname, lastname, email, searchby) {
    if (searchby === "email") {
      let myroute = servername + "/searchToAddToEveryoneEmail";
      const params = {
        userID: userID,
        searchTerm: email,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
    }

    if (searchby === "name") {
      let myroute = servername + "/searchToAddToEveryoneName";
      const params = {
        userID: userID,
        searchTermFirst: firstname,
        searchTermLast: lastname,
        token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
      };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
    
    }
  },
  async addToEveryone(userID, selected) {
    let myroute = servername + "/addToEveryone";
    const params = {
      selected: selected,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getEveryoneMembersToAdd(userID, circleID) {
    let myroute = servername + "/geteveryonememberstoadd";
    const params = {
      userID: userID,
      circleID: circleID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async updateCircle(circleID, circleName) {
    let myroute = servername + "/updatecircle";
    const params = {
      circleID: circleID,
      circleName: circleName,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async newCircle(circleName, userID) {
    let myroute = servername + "/newcircle";
    const params = {
      circleName: circleName,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async addCircleMember(memberID, circleID, userID) {
    let myroute = servername + "/addcirclemember";
    const params = {
      memberID: memberID,
      circleID: circleID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async deleteCircle(circleID, userID) {
    let myroute = servername + "/deletecircle";
    const params = {
      circleID: circleID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data[0];} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async deleteCircleMember(memberID, circleID) {
    let myroute = servername + "/deletecirclemember";
    const params = {
      memberID: memberID,
      circleID: circleID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },
  async deleteEveryoneCircleMember(memberID, userID) {
    let myroute = servername + "/deleteeveryonecirclemember";
    const params = {
      memberID: memberID,
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //Invitation
  async myOpenInvitations(userID) {
    let myroute = servername + "/myopeninvitations";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async mySentInvitations(userID) {
    let myroute = servername + "/mysentinvitations";
    const params = {
      userID: userID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async acceptInvitation(userID, circleMemID) {
    let myroute = servername + "/acceptinvitation";
    const params = {
      userID: userID,
      circleMemID: circleMemID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async declineInvitation(userID, circleMemID) {
    let myroute = servername + "/declineinvitation";
    const params = {
      userID: userID,
      circleMemID: circleMemID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  //Profile stuff

  async getProfileUser(profileID) {
    let myroute = servername + "/profileuser";
    const params = {
      profileID: profileID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async getTimeZones() {
    let myroute = servername + "/gettimezones";
    const params = {
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getProfileMemories(
    userID,
    profileID,
    contentType,
    recordStart,
    pageLength
  ) {
    let myroute = servername + "/profilememories";
    const params = {
      userID: userID,
      profileID: profileID,
      contentType: contentType,
      recordStart: recordStart,
      pageLength: pageLength,
      recordCount: 0,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getProfileJournals(
    userID,
    profileID,
    recordStart,
    pageLength
  ) {
    let myroute = servername + "/profilejournals";
    const params = {
      userID: userID,
      profileID: profileID,
      recordStart: recordStart,
      pageLength: pageLength,
      recordCount: 0,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
   // console.log('params for journals is: ', params)
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getProfileBookList(userID, profileID) {
    let myroute = servername + "/getProfileBookList";
    const params = {
      userID: userID,
      profileID: profileID,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },
  async sendInvitation(userID, invitee, email, tcDate, invitedBy, userSubType) {
    let myroute = servername + "/sendInvitation";
    const params = {
      userID: userID,
      invitee: invitee,
      email: email,
      tcDate: tcDate,
      invitedBy: invitedBy,
      userSubType: userSubType,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

    async sendAdminInvitation(userID, invitee, email, tcDate, invitedBy, userSubType) {
    let myroute = servername + "/sendAdminInvitation";
    const params = {
      userID: userID,
      invitee: invitee,
      email: email,
      tcDate: tcDate,
      invitedBy: invitedBy,
      userSubType: userSubType,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
  //  console.log('es sees invitation return as: ', res)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getFreeInvitations(userID, userSubType) {
    let myroute = servername + "/getFreeInvitations";
    const params = {
      userID: userID,
      userSubType: userSubType,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
    try {let res = await axios.get(myroute, { params });
      return res.data;} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async sendQCSuggestion(userID, qcSuggestion) {
    let myroute = servername + "/saveQCSuggestion";
    const params = {
      userID: userID,
      qcSuggestion: qcSuggestion,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
        try {let res = await axios.get(myroute, { params });
            if (res.status === 200) {
      return "success";
    } else {
      return "error";
    }
} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async sendInterviewSuggestion(userID, interviewSuggestion) {
    let myroute = servername + "/saveInterviewSuggestion";
    const params = {
      userID: userID,
      interviewSuggestion: interviewSuggestion,
      token: store.getters.getToken,
      reauthToken: store.getters.getReauthToken
    };
        try {let res = await axios.get(myroute, { params });
            if (res.status === 200) {
      return "success";
    } else {
      return "error";
    }
} 
    catch (error) {console.log('send the user to the login page',  error)
    if (process.env.VUE_APP_SERVERNAME === 'http://localhost:8700') {
    location.href = '//localhost:8080/login';} else {
      location.href = 'https://login.memoriesforus.com/login';
    }
  } 
  },

  async getInvitation(invitationID) {
    let myroute = servername + "/getInvitation";
    const params = {
      invitationID: invitationID,
    };
    let res = await axios.get(myroute, { params });
    return res.data;
  },
};
